import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dateToServerFormat, dateToSlice, getMomentDate } from "../../utils";
import { cancelSingleAppointment, getDayAvailability, rescheduleSingleAppointment } from "../../store/appointment/appointmentActions";
import { Controller, useForm } from "react-hook-form";
import Calendar from "react-calendar";
import ReactSelect from "react-select";

const CancelEvent = ({ setIsCancel, event, refreshParent }) => {

    const dispatch = useDispatch();
    const { handleSubmit, control, register } = useForm()

    const handleCancel = (data) => {
        dispatch(cancelSingleAppointment({ id: data._id, reason: data.reason.label, message: data.message }))
            .unwrap()
            .then(v => refreshParent())
    }

    const {currentProfile} = useSelector(state => state.profile)
    const IssueOptions = [
        ...(currentProfile.role == 2 ? [
            { value: 1, label: "Health issues" },
            { value: 2, label: "I am taking leave" },
            { value: 3, label: "I wish to change my rates" },
            { value: 4, label: "I have another commitment" },
            { value: 5, label: "I have a technical problem" },
            { value: 6, label: "Other" },
        ]
            : currentProfile.role == 3 ?
                [
                    { value: 1, label: "Health issues" },
                    { value: 4, label: "I have another commitment" },
                    { value: 5, label: "I have a technical problem" },
                    { value: 6, label: "Other" },
                ]
                : []
        )
    ]

    return <div>
        <form className="flex flex-col gap-5" onSubmit={handleSubmit((data) => handleCancel(data))}>
            <h3 className="text-nt-blue">Cancel Course</h3>
            <div className="flex">
                <div className="w-full">
                    <Controller
                        control={control}
                        name="reason"
                        render={({ field: { onChange, value } }) => (
                            <ReactSelect
                                className="w-full"
                                placeholder="Reason"
                                required={true}
                                onChange={onChange}
                                value={value || ''}
                                options={IssueOptions}
                            />
                        )}
                    />
                    <input name="_id" {...register("_id")} type="hidden" value={event._id} />
                    {/* <textarea required name="message" {...register("message")} rows={6} className="w-full mt-5 flex-grow border-nt-grey border-2 rounded p-1" placeholder="Message"></textarea> */}
                </div>
            </div>
            <div className="flex justify-center gap-5">
                <button className="w-40 bg-nt-blue text-white px-2 py-3 rounded">Cancel Course</button>
                <button type="button" className="w-40 bg-nt-grey text-white px-2 py-3 rounded" onClick={() => setIsCancel(false)}>Cancel</button>
            </div>
        </form>
    </div>
}
export { CancelEvent }